export const Payments = () => {
  return (
    <></>
  )
}